import { Injectable } from '@angular/core';

export interface Notification {
	date: Date;
	description: string;
	id: string;
	viewed?: boolean;
}

@Injectable({
	providedIn: 'root',
})
export class NotificationService {
	private notifications: Notification[] = [];

	constructor() {}

	addNotification(notification: Notification): void {
		if (this.notifications.length > 4) this.notifications.shift();

		this.notifications.push({ ...notification, viewed: false });
	}

	markAsViewed(): void {
		for (const notification of this.notifications) {
			notification.viewed = true;
		}
	}

	newNotification(): boolean {
		return this.notifications.some((el) => !el.viewed);
	}

	getNotifications(): Notification[] {
		const notifications = this.notifications.map(
			(el) => ({ ...el } as Notification)
		);

		this.markAsViewed();

		return notifications;
	}
}
